export const productThunkNames = {
    fetchProducts: 'fetchProducts',
};
